module.exports = __webpack_public_path__ + "static/media/3K.36854a06.png";